<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <router-view />
  
</template>

<style>
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
}
html{
  background: rgb(46, 46, 46);
}
body{
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
}

</style>